import React, { createContext, useContext, useEffect, useState } from "react";
import {
  AddTrxToDB,
  getDocuments,
  getPaginatedDocuments,
  getSingleDocument,
} from "../utils/firebase.helper";
import {
  fetchBlockHeightFromRPC,
  fetchCoinData,
  getTruncatedTrx,
} from "../utils/helper";
import {
  fetchTokenBalance,
  fetchTotalStakedToken,
  fetchTrxTime,
  getFailedTrxTime,
  getReward,
  getWaitTransaction,
} from "../utils/wagmi.helper";
import { useRootContext } from "./app-context";
import { toast } from "react-toastify";
import {
  errorTexts,
  generalIcons,
  status,
  vanarExplorerUrl,
} from "../utils/constants";
import stakingAbi from "../blockchain/abi/staking.json";
import useWalletConnection from "../hooks/useWalletConnections";
import { useLocation } from "react-router-dom";

const StakingContext = createContext();

export const StakingContextProvider = ({ children }) => {
  const {pathname: path} = useLocation()
  const { address, isSignWallet, isConnected } = useRootContext();
  const currentValidator = JSON.parse(
    localStorage?.getItem("selectedValidator"),
  );
  const [calculatorApy, setCalculatorApy] = useState(0);
  const [isTrxSuccess, setIsTrxSuccess] = useState(false);
  const previousView = localStorage?.getItem("previousView");
  const [isClaimModalOpen, setIsClaimModalOpen] = useState(false);
  const [isDelegatorModalOpen, setIsDelegatorModalOpen] = useState(false);
  const [view, setView] = useState(previousView ?? "grid");
  const [isFetchingUnstakeBalance, setIsFetchingUnstakeBalance] =
    useState(false);
  const [faqs, setFaqs] = useState();
  const [overview, setOverview] = useState({
    total_dPoS_validators: 0,
    block_height: 0,
    total_staked: 0,
    total_rewards_distributed: 0,
    // last_checkpoint: 0,
    // checkpoint_interval: 0,
    // performance_benchmark: 0,
  });
  const [overviewTooltipDetail, setOverviewTooltipDetail] = useState();
  const [calculatorOverview, setCalculatorOverview] = useState({
    price: 0,
    market_cap: 0,
    total_staked: 0,
    total_dPoS_validators: 0,
    // active_validators_set: "0/0",
  });

  const [selectedValidator, setSelectedValidator] = useState(
    currentValidator
      ? currentValidator
      : {
        name: "",
        performance: 0,
        commission: 0,
        contract_address: "",
        checkpoint_signed: 0,
        total_staked: 0,
        validator_stake: 0,
        total_rewards_distributed: 0,
        health_status: "Healthy",
        performance_index: 0,
        delegators: [],
        status: "inactive",
      },
  );

  const [btnloading, setBtnloading] = useState(false);
  const [validators, setValidators] = useState();
  const [enterpriseValidators, setEnterpriseValidators] = useState();
  const [userValidators, setUserValidators] = useState();
  const [userDelegators, setUserDelegators] = useState(null);
  const [userTrxHistory, setUserTrxHistory] = useState();
  const [coinData, setCoinData] = useState(null);
  const [availableBalance, setAvailableBalance] = useState(0);
  const [availableStakedBalance, setAvailableStakedBalance] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [isStakeAmountConfirmed, setIsStakeAmountConfirmed] = useState(false);
  const [isUnStakeAmountConfirmed, setIsUnStakeAmountConfirmed] =
    useState(false);
  const [isTrxHistoryBtnLoading, setIsTrxHistoryBtnLoading] = useState(false);
  const [isMaxSelected, setIsMaxSelected] = useState(false);
  const [isTermsAgreed, setIsTermsAgreed] = useState(false);
  const [isClaimed, setIsClaimed] = useState(false);
  const [trxData, setTrxData] = useState();
  const [trx, setTrx] = useState(localStorage?.getItem("trxData") || "");
  const [isFetchingOverview, setIsFetchingOverview] = useState(true);
  const [isConfirmDisabled, setIsConfirmDisabled] = useState(!inputValue);
  const [isFetchingTrx, setIsFetchingTrx] = useState(false);
  const [isFetchingMyAccountDetails, setIsFetchingMyAccountDetails] =
    useState(true);
  const [IsFetchingWalletInfo, setIsFetchingWalletInfo] = useState(true);
  const [isFetchingCalculatorOverview, setIsFetchingCalculatorOverview] =
    useState(true);
  const [validatorDelgatorSummary, setValidatorDelgatorSummary] = useState({
    total_delegators: 0,
    total_dPoS_validators: 0,
    active_validators: 0,
    inactive_validators: 0,
  });

  const { changedAddress, setIsAccountsChanged } = useWalletConnection({
    isConnected,
    setUserDelegators,
  });

  const [lastTransactionDoc, setLastTransactionDoc] = useState(null);
  const [lastClaimDoc, setLastClaimDoc] = useState(null);

  // const { vanryPrice, marketCap } = useVanryData();

  const fetchOverview = async (updatedValidators) => {
    const response = await getSingleDocument("/vanar-dpos", "data");
    const faqResponse = await getSingleDocument("/vanar-dpos", "faq");
    const blockHeight = await fetchBlockHeightFromRPC();
    // const totalValidators =
    //   response?.total_dPoS_validators === updatedValidators?.length
    //     ? response?.total_dPoS_validators
    //     : updatedValidators?.length;

    const obj = {
      total_dPoS_validators: response.total_validators,
      block_height: blockHeight,
      total_staked: response.total_staked,
      total_rewards_distributed: response.total_rewards_distributed,
      // last_checkpoint: 0,
      // checkpoint_interval: 0,
      // performance_benchmark: response.performance_benchmark,
    };

    const validatorDelgatorSummaryObj = {
      total_delegators: response.total_delegators,
      total_dPoS_validators: response.total_validators,
      active_validators: response.active_validators,
      inactive_validators: response.inactive_validators,
    };
    setCalculatorApy(response.calculator_apy);
    setOverview(obj);
    setOverviewTooltipDetail(response.overview_tooltip_detail);
    setValidatorDelgatorSummary(validatorDelgatorSummaryObj);
    setFaqs(faqResponse.faqs);
    setIsFetchingOverview(false);
  };

  const fetchValidators = async () => {
    const response = await getDocuments("/vanar-dpos/data/validators");
    const nonEpValidators = response?.filter(
      (data) => data?.is_enterprise === false,
    );
    const epValidators = response
    ?.filter((data) => data?.is_enterprise === true)
    ?.sort((a, b) => {
      if (a.status < b.status) {
        return -1; // a comes before b
      }
      if (a.status > b.status) {
        return 1; // b comes before a
      }
      return 0; // a and b are equal
    });

    setEnterpriseValidators(epValidators);
    setValidators(nonEpValidators);
    fetchOverview(nonEpValidators);
  };

  const fetchIsValidator = async (validatorAddress, ownerAddress) => {
    const isDelegator = await getSingleDocument(
      `/vanar-dpos/data/validators/${validatorAddress}/delegators`,
      ownerAddress,
    );

    return isDelegator
  }

  const fetchValidatorDelegators = async (validatorAddress, currentLastDoc) => {
    let lastDoc = currentLastDoc; // Initially, no last document
    let allData = [];

    try {
      const firstPage = await getPaginatedDocuments(
        `/vanar-dpos/data/validators/${validatorAddress}/delegators`, // Collection path
        'update_time',      // Order by attribute
        'desc',             // Order direction
        10,                 // Limit per page
        lastDoc             // Last document reference for pagination
      );

      // Filter delegators with stake_value > 0
      const eligibleDelegators = firstPage.docs.filter((data) => data?.stake_value > 0);

      // Update data and lastDoc
      allData = [...eligibleDelegators];
      lastDoc = firstPage.lastVisible;

      // Return the filtered delegators and lastDoc for pagination
      return { allData, lastDoc };
    } catch (error) {
      console.error("Error fetching delegators:", error);
      return { allData, lastDoc }; // Return empty array if there's an error
    }
  };


  const fetchUserTransactions = async () => {
    // setIsFetchingTrx(true);

    const [userTransactions, userClaimRewardLatestTrx] = await Promise.all([
      getDocuments(`/vanar-dpos/data/user_data/${address}/transactions`, "date", "desc"),
      getDocuments(`/vanar-dpos/data/user_data/${address}/rewards`, "distribution_date", "desc"),
    ]);

    const claimtrxPromises = userClaimRewardLatestTrx.map(async (trx) => {
      const transactions = await getDocuments(
        `/vanar-dpos/data/user_data/${address}/rewards/${trx.id}/transactions`,
        "date",
        "desc"
      );
      return transactions.filter((t) => t.type === "Claim Reward");
    });

    const claimtrx = (await Promise.all(claimtrxPromises)).flat();

    const allTransactions = [...userTransactions, ...claimtrx];

    allTransactions.sort((a, b) => b.date - a.date);

    setUserTrxHistory(allTransactions);
    // setIsFetchingTrx(false);
  };

  // const fetchUserTransactions = async (lastTransactionDoc = null, lastClaimDoc = null, append = false) => {

  //   if(!append){
  //     setIsFetchingTrx(true);
  //   }

  //   const limit = 10;

  //   // Fetch paginated user transactions
  //   const userTrxResult = await getPaginatedDocuments(
  //     `/vanar-dpos/data/user_data/${address}/transactions`,
  //     "date",
  //     "desc",
  //     limit,
  //     lastTransactionDoc
  //   );

  //   // Fetch paginated user reward transactions
  //   const rewardTrxResult = await getPaginatedDocuments(
  //     `/vanar-dpos/data/user_data/${address}/rewards`,
  //     "distribution_date",
  //     "desc",
  //     limit,
  //     lastClaimDoc
  //   );

  //   // Fetch claim transactions for each reward
  //   const claimtrxPromises = rewardTrxResult.docs.map(async (trx) => {
  //     const claimResult = await getPaginatedDocuments(
  //       `/vanar-dpos/data/user_data/${address}/rewards/${trx.id}/transactions`,
  //       "date",
  //       "desc",
  //       limit
  //     );
  //     return claimResult.docs.filter((t) => t.type === "Claim Reward");
  //   });

  //   const claimtrx = (await Promise.all(claimtrxPromises)).flat();

  //   // Combine and sort transactions
  //   const allTransactions = [...userTrxResult.docs, ...claimtrx];
  //   allTransactions.sort((a, b) => b.date - a.date);

  //   // Append or replace data in the state
  //   setUserTrxHistory((prev) => (append ? [...prev, ...allTransactions] : allTransactions));

  //   // Save the last document references for pagination
  //   setLastTransactionDoc(userTrxResult.lastVisible);
  //   setLastClaimDoc(rewardTrxResult.lastVisible);

  //   setIsFetchingTrx(false);
  // };


  const fetchTotalStakedBalance = async () => {
    setIsFetchingUnstakeBalance(true);
    const obj = {
      stakeContract: selectedValidator?.contract_address,
      tokenContractAbi: stakingAbi,
      walletAddress: address,
    };
    const response = await fetchTotalStakedToken(obj);
    setAvailableStakedBalance(response);
    setIsFetchingUnstakeBalance(false);
  };

  // const fetchUserData = async () => {
  //   const currentAddress = changedAddress ?? address; // Use nullish coalescing for clarity
  //   setIsAccountsChanged(false);

  //   // Filter validators for the current address
  //   const userCurrentValidators = validators?.filter(
  //     (validator) => validator?.owner_wallet_address === currentAddress
  //   );

  //   // Fetch user data for the current address
  //   const delegatorData = await getSingleDocument(
  //     "/vanar-dpos/data/user_data",
  //     currentAddress
  //   );

  //   const validatorContracts = delegatorData?.validator_contracts ?? [];
  //   let userCurrentDelegators = [];

  //   if (validatorContracts.length > 0) {
  //     // Use Promise.all for parallel fetching
  //     await Promise.all(
  //       validatorContracts.map(async (validatorContract) => {
  //         // Find the validator for the contract
  //         const currentDelegator = validators?.find(
  //           (validator) => validator?.id === validatorContract
  //         );

  //         if (currentDelegator) {
  //           // Add user rewards
  //           const userRewards = {
  //             total_claimed_comission: delegatorData?.total_claimed_comission,
  //             total_claimed_rewards: delegatorData?.total_claimed_rewards,
  //             total_unclaimed_comission: delegatorData?.total_unclaimed_comission,
  //             total_unclaimed_rewards: delegatorData?.total_unclaimed_rewards,
  //           };

  //           currentDelegator.amount = delegatorData?.stake_value;
  //           currentDelegator.rewards_earned = delegatorData?.total_dis_rewards;
  //           currentDelegator.rewards = userRewards;

  //           // Check if the current address matches the validator's owner wallet
  //           if (currentDelegator?.owner_wallet_address !== currentAddress) {
  //             const validatorEarnedCommission = await getSingleDocument(
  //               `/vanar-dpos/data/validators/${validatorContract}/delegators`,
  //               currentDelegator?.owner_wallet_address
  //             );

  //             currentDelegator.validator_commission_earned =
  //               (validatorEarnedCommission?.total_unclaimed_comission ?? 0) +
  //               (validatorEarnedCommission?.total_claimed_comission ?? 0);
  //           }

  //           userCurrentDelegators.push(currentDelegator);
  //         }
  //       })
  //     );

  //     // Update state after processing all delegators
  //     setUserDelegators(userCurrentDelegators);
  //   } else {
  //     setUserValidators([]);
  //     setUserDelegators([]);
  //   }

  //   // Update validators
  //   setUserValidators(userCurrentValidators);
  // };


  // const handleSetCalculatorOverview = async () => {
  //   const totalValidators =
  //     validatorDelgatorSummary?.total_dPoS_validators ===
  //       validators?.length
  //       ? validatorDelgatorSummary?.total_dPoS_validators
  //       : validators?.length;
  //   const obj = {
  //     price: vanryPrice,
  //     market_cap: marketCap,
  //     total_staked: overview?.total_staked,
  //     total_dPoS_validators: totalValidators,
  //     // active_validators_set: `${validatorDelgatorSummary?.active_validators < 10 ? "0" : ""}${validatorDelgatorSummary?.active_validators}/${validators?.length < 10 ? "0" : ""}${validators?.length}`,
  //   };
  //   setCalculatorOverview(obj);
  //   setIsFetchingCalculatorOverview(false);
  // };

  const fetchUserData = async () => {
    const currentAddress = changedAddress ?? address; // Use nullish coalescing for clarity
    setIsAccountsChanged(false);

    // Filter validators for the current address
    const userCurrentValidators = validators?.filter(
      (validator) => validator?.owner_wallet_address === currentAddress
    );


    // Fetch user data for the current address
    const response = await getSingleDocument("/vanar-dpos/data/user_data", currentAddress);
    localStorage?.setItem("prevBalance", response?.stake_value)
    localStorage?.setItem("lastUpdatedAt", response?.realtime_update)

    const validatorContracts = response?.validator_contracts ?? [];
    let userCurrentDelegators = [];

    if (validatorContracts.length > 0) {
      // Use Promise.all for parallel fetching
      const delegatorPromises = validatorContracts.map(async (validatorContract) => {
        const [delegatorData, currentDelegator, rewards] = await Promise.all([
          getSingleDocument(`/vanar-dpos/data/validators/${validatorContract}/delegators`, currentAddress),
          validators?.find((validator) => validator?.id === validatorContract),
          getReward({stakeContract: validatorContract, tokenContractAbi: stakingAbi, walletAddress: currentAddress})
        ]);


        const userRewards = {
          total_claimed_comission: delegatorData?.total_claimed_comission,
          total_claimed_rewards: delegatorData?.total_claimed_rewards,
          total_unclaimed_comission: delegatorData?.total_unclaimed_comission,
          total_unclaimed_rewards: delegatorData?.total_unclaimed_rewards,
          totalRewards: Number(rewards)
        }

        if (currentDelegator) {
          currentDelegator.amount = delegatorData?.stake_value;
          currentDelegator.rewards_earned = delegatorData?.total_dis_rewards;
          currentDelegator.rewards = userRewards;

          if (currentDelegator?.owner_wallet_address !== currentAddress ||currentDelegator?.owner_wallet_address === currentAddress ) {
            const validatorEarnedCommission = await getSingleDocument(
              `/vanar-dpos/data/validators/${validatorContract}/delegators`,
              currentDelegator?.owner_wallet_address
            );
            currentDelegator.validator_commission_earned =
              validatorEarnedCommission?.total_unclaimed_comission +
              validatorEarnedCommission?.total_claimed_comission;
          }

          userCurrentDelegators.push(currentDelegator);
        }
      });

      // Wait for all promises to resolve
      await Promise.all(delegatorPromises);

      setUserDelegators(userCurrentDelegators);
    } else {
      setUserValidators([]);
      setUserDelegators([]);
    }

    setUserValidators(userCurrentValidators);
  };


  const handleWalletInfo = async () => {
    const availableTokenBalance = await fetchTokenBalance(address, "");
    setAvailableBalance(availableTokenBalance);
    setIsFetchingWalletInfo(false);
  };

  useEffect(() => {
    const validatorName = selectedValidator?.contract_address

    const excludedPaths = ["claim", "delegate", "unstake"];

    if (
      !path.includes(validatorName) &&
      !excludedPaths.some((segment) => path.includes(segment))
    ) {
      localStorage?.removeItem("selectedValidator");
    }
  }, [window?.location?.pathname]);

  useEffect(() => {
    if (isSignWallet && address) {
      handleWalletInfo();
    } else {
      setIsTermsAgreed(false);
      setIsStakeAmountConfirmed(false);
      setInputValue("");
      setIsConfirmDisabled(true);
      setAvailableBalance(0);
      setUserDelegators(null);
    }
  }, [isSignWallet, address]);

  useEffect(() => {
    if((path === "/" || path === "/all-validator" || path === "/my-account") && validators=== undefined){
      fetchValidators();
    }
  }, [path]);


  useEffect(() => {
    if (
      selectedValidator?.contract_address?.length > 0 &&
      isSignWallet &&
      path?.includes("unstake")
    ) {
      fetchTotalStakedBalance();
    }
  }, [selectedValidator, isSignWallet, address]);

  // useEffect(() => {
  //   if (validatorDelgatorSummary?.total_dPoS_validators > 0) {
  //     handleSetCalculatorOverview();
  //   }
  // }, [validatorDelgatorSummary]);

  const handleErrorTransaction = async (error) => {
    console.log(error);
    const trxTime = await getFailedTrxTime(trx.t_hash);
    const db_data = {
      date: trxTime,
      txId: trxData?.txId,
      to: trxData?.to,
      from: trxData?.from,
      amount: Number(trxData?.tvk),
      txType: trxData?.txType,
      status: "failed",
    };
    AddTrxToDB(db_data);
    setBtnloading(!btnloading);
    toast.error(
      <div className="flex items-center gap-4">
        <span className="icon">{generalIcons.error}</span>
        <div className="">
          <p>{errorTexts.unknown}</p>
        </div>
      </div>,
    );
  };

  // useEffect(() => {
  //   if (trx.t_hash && isSignWallet) {
  //     getWaitTransaction(trx.t_hash)
  //       .then(async (transaction) => {
  //         if (transaction?.status === "success") {
  //           if (
  //             trx.type === status.STAKING ||
  //             trx.type === status.UNSTAKING ||
  //             trx.type === status.CLAIM_STAKE ||
  //             trx.type === status.CLAIM_REWARD
  //           ) {
  //             const trxTime =
  //               trx.type === status.UNSTAKING
  //                 ? Math.floor(Date.now() / 1000)
  //                 : fetchTrxTime(transaction?.logs[0]?.data);
  //             // const trxTime = fetchTrxTime(transaction?.logs[isNative ? 0 : isUnstakeSelected ? 1  : 2]?.data);
  //             const db_data = {
  //               date: trxTime,
  //               txId: trxData?.txId,
  //               to: trxData?.to,
  //               from: trxData?.from,
  //               amount: Number(trxData?.tvk),
  //               txType: trxData?.txType,
  //               status: "completed",
  //             };

  //             if (trxData?.txType === "Claim Stake") {
  //               db_data.unstakeTrx = trxData?.unstakeTrx;
  //             }

  //             await Promise.resolve(setTimeout(() => { }, 500));

  //             AddTrxToDB(db_data).finally(() => {
  //               toast.success(
  //                 <div className="flex items-center gap-4">
  //                   <span className="icon">
  //                     {generalIcons.success}
  //                   </span>
  //                   <div className="">
  //                     <h5>
  //                       {trx.type !==
  //                         status.CLAIM_REWARD &&
  //                         `Successfully${" "}`}
  //                       {trx.type === status.STAKING
  //                         ? "Staked"
  //                         : trx.type ===
  //                           status.CLAIM_STAKE
  //                           ? "Claimed"
  //                           : trx.type ===
  //                             status.CLAIM_REWARD
  //                             ? "Reward Claimed Successfully"
  //                             : "Unstaked"}{" "}
  //                     </h5>
  //                     <p>
  //                       Transaction ID:{" "}
  //                       <a
  //                         href={`${vanarExplorerUrl}/tx/${transaction.transactionHash}`}
  //                         rel="noreferrer"
  //                         target="_blank"
  //                         className="address"
  //                       >
  //                         {getTruncatedTrx(
  //                           transaction.transactionHash,
  //                         )}
  //                       </a>
  //                     </p>
  //                   </div>
  //                 </div>,
  //               );
  //               setIsClaimModalOpen(false);
  //               setIsFetchingWalletInfo(true);
  //               setIsTrxSuccess(true);
  //               setBtnloading(!btnloading);
  //               setIsConfirmDisabled(true);
  //               setInputValue("");
  //               setIsMaxSelected(false);
  //               setIsTermsAgreed(false);
  //               setIsStakeAmountConfirmed(false);
  //               setIsUnStakeAmountConfirmed(false);
  //               setIsClaimed(true);
  //               setIsTrxHistoryBtnLoading(false);
  //               localStorage.setItem(
  //                 "trxStatus",
  //                 status.SUCCESS,
  //               );
  //               localStorage.removeItem("trxData");
  //               handleWalletInfo();
  //               fetchUserTransactions();
  //               fetchUserData();
  //             });
  //           }
  //         }
  //       })
  //       .catch(async (error) => {
  //         handleErrorTransaction(error);
  //       });
  //   }
  // }, [trx, isSignWallet]);

  const contextValue = React.useMemo(
    () => ({
      coinData,
      overview,
      validators,
      availableBalance,
      calculatorOverview,
      isFetchingOverview,
      IsFetchingWalletInfo,
      isFetchingCalculatorOverview,
      inputValue,
      setInputValue,
      isStakeAmountConfirmed,
      setIsStakeAmountConfirmed,
      isUnStakeAmountConfirmed,
      setIsUnStakeAmountConfirmed,
      isTermsAgreed,
      setIsTermsAgreed,
      isConfirmDisabled,
      setIsConfirmDisabled,
      selectedValidator,
      setSelectedValidator,
      btnloading,
      setBtnloading,
      isMaxSelected,
      setIsMaxSelected,
      trxData,
      setTrxData,
      trx,
      setTrx,
      userValidators,
      userDelegators,
      userTrxHistory,
      calculatorApy,
      availableStakedBalance,
      isClaimed,
      isTrxHistoryBtnLoading,
      setIsTrxHistoryBtnLoading,
      view,
      setView,
      isFetchingUnstakeBalance,
      isFetchingTrx,
      isFetchingMyAccountDetails,
      overviewTooltipDetail,
      isTrxSuccess,
      setIsTrxSuccess,
      isClaimModalOpen,
      setIsClaimModalOpen,
      fetchUserData,
      enterpriseValidators,
      fetchValidatorDelegators,
      fetchIsValidator,
      fetchUserTransactions,
      lastClaimDoc,lastTransactionDoc,
      setCalculatorOverview,
      setIsFetchingCalculatorOverview,
      setUserTrxHistory,
      setIsFetchingTrx,
      setIsFetchingMyAccountDetails,
      fetchValidators,
      handleWalletInfo,
      isDelegatorModalOpen, setIsDelegatorModalOpen
    }),
    [
      coinData,
      availableBalance,
      overview,
      calculatorOverview,
      isFetchingOverview,
      IsFetchingWalletInfo,
      isFetchingCalculatorOverview,
      validators,
      inputValue,
      setInputValue,
      isStakeAmountConfirmed,
      setIsStakeAmountConfirmed,
      isUnStakeAmountConfirmed,
      setIsUnStakeAmountConfirmed,
      isTermsAgreed,
      setIsTermsAgreed,
      isConfirmDisabled,
      setIsConfirmDisabled,
      selectedValidator,
      setSelectedValidator,
      btnloading,
      setBtnloading,
      isMaxSelected,
      setIsMaxSelected,
      trxData,
      setTrxData,
      trx,
      setTrx,
      userValidators,
      userDelegators,
      userTrxHistory,
      calculatorApy,
      availableStakedBalance,
      isClaimed,
      isTrxHistoryBtnLoading,
      setIsTrxHistoryBtnLoading,
      view,
      setView,
      isFetchingUnstakeBalance,
      isFetchingTrx,
      isFetchingMyAccountDetails,
      overviewTooltipDetail,
      isTrxSuccess,
      setIsTrxSuccess,
      isClaimModalOpen,
      setIsClaimModalOpen,
      fetchUserData,
      enterpriseValidators,
      fetchValidatorDelegators,
      fetchIsValidator,
      fetchUserTransactions,
      lastClaimDoc,lastTransactionDoc,
      setCalculatorOverview,
      setIsFetchingCalculatorOverview,
      setUserTrxHistory,
      setIsFetchingTrx,
      setIsFetchingMyAccountDetails,
      fetchValidators,
      handleWalletInfo,
      isDelegatorModalOpen, setIsDelegatorModalOpen
    ],
  );
  return (
    <StakingContext.Provider value={contextValue}>
      {children}
    </StakingContext.Provider>
  );
};

export default StakingContextProvider;

export const useStakingContext = () => {
  const {
    coinData,
    overview,
    validators,
    availableBalance,
    calculatorOverview,
    isFetchingOverview,
    IsFetchingWalletInfo,
    isFetchingCalculatorOverview,
    inputValue,
    setInputValue,
    isStakeAmountConfirmed,
    setIsStakeAmountConfirmed,
    isUnStakeAmountConfirmed,
    setIsUnStakeAmountConfirmed,
    isTermsAgreed,
    setIsTermsAgreed,
    isConfirmDisabled,
    setIsConfirmDisabled,
    selectedValidator,
    setSelectedValidator,
    btnloading,
    setBtnloading,
    isMaxSelected,
    setIsMaxSelected,
    trxData,
    setTrxData,
    trx,
    setTrx,
    userValidators,
    userDelegators,
    userTrxHistory,
    calculatorApy,
    availableStakedBalance,
    isClaimed,
    isTrxHistoryBtnLoading,
    setIsTrxHistoryBtnLoading,
    view,
    setView,
    isFetchingUnstakeBalance,
    isFetchingTrx,
    isFetchingMyAccountDetails,
    overviewTooltipDetail,
    isTrxSuccess,
    setIsTrxSuccess,
    isClaimModalOpen,
    setIsClaimModalOpen,
    fetchUserData,
    enterpriseValidators,
    fetchValidatorDelegators,
    fetchIsValidator,
    fetchUserTransactions,
    lastClaimDoc,lastTransactionDoc,
    setCalculatorOverview,
    setIsFetchingCalculatorOverview,
    setUserTrxHistory,
    setIsFetchingTrx,
    setIsFetchingMyAccountDetails,
    fetchValidators,
    handleWalletInfo,
    isDelegatorModalOpen, setIsDelegatorModalOpen
  } = useContext(StakingContext);
  return {
    coinData,
    overview,
    validators,
    availableBalance,
    calculatorOverview,
    isFetchingOverview,
    IsFetchingWalletInfo,
    isFetchingCalculatorOverview,
    inputValue,
    setInputValue,
    isStakeAmountConfirmed,
    setIsStakeAmountConfirmed,
    isUnStakeAmountConfirmed,
    setIsUnStakeAmountConfirmed,
    isTermsAgreed,
    setIsTermsAgreed,
    isConfirmDisabled,
    setIsConfirmDisabled,
    selectedValidator,
    setSelectedValidator,
    btnloading,
    setBtnloading,
    isMaxSelected,
    setIsMaxSelected,
    trxData,
    setTrxData,
    trx,
    setTrx,
    userValidators,
    userDelegators,
    userTrxHistory,
    calculatorApy,
    availableStakedBalance,
    isClaimed,
    isTrxHistoryBtnLoading,
    setIsTrxHistoryBtnLoading,
    view,
    setView,
    isFetchingUnstakeBalance,
    isFetchingTrx,
    isFetchingMyAccountDetails,
    overviewTooltipDetail,
    isTrxSuccess,
    setIsTrxSuccess,
    isClaimModalOpen,
    setIsClaimModalOpen,
    fetchUserData,
    enterpriseValidators,
    fetchValidatorDelegators,
    fetchIsValidator,
    fetchUserTransactions,lastClaimDoc,lastTransactionDoc,
    setCalculatorOverview,
    setIsFetchingCalculatorOverview,
    setUserTrxHistory,
    setIsFetchingTrx,
    setIsFetchingMyAccountDetails,
    fetchValidators,
    handleWalletInfo,
    isDelegatorModalOpen, setIsDelegatorModalOpen
  };
};
